export default {
  "content": "<path d=\"M11.927 4.98a6 6 0 10-11.12 4l4.146 6.42a1.247 1.247 0 002.1 0l4.154-6.42a6 6 0 00.72-4zM6 9.333a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667z\" fill=\"#717684\"/>",
  "attrs": {
    "width": "13",
    "height": "16",
    "viewBox": "0 0 13 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};